export enum EnumPerfiles {
    CallCenter = 1,
    Comercial = 2,
    Analista = 3,
    Tecnico = 4,
    Gerente = 5
}